import contract, {selectors} from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import remove from './remove/remove.js'
import redirect from '#utilities/js/hotkey/redirect.js'

export default contract({
    [selectors]: {
        'slot[data-name="hotkey-delete"]': array([
            remove
        ]),
        'slot[data-name="hotkey-next"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-previous"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-first"]': array([
            redirect
        ]),
    }
})